import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScenarioService } from '../services/scenario.service';
import * as WebFont from 'webfontloader';
import { PlayerSessionService } from '../services/player-session.service';
import * as dayjs from 'dayjs';
import Swal from 'sweetalert2';
import { Meta, Title } from '@angular/platform-browser';
import { UserService } from '../auth/service/user.service';
import { LibraryService } from '../services/library.service';

declare function ScormProcessInitialize(): any;
declare const window: any;
declare var xapiActor: any;
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  scenario: any;
  startStep: any;
  startStepId: any;
  saveSessionInterval: any;
  sessionCreated = false;
  scenarioId: any;
  publishedHash: any;
  user: any = {};
  activeSessionId: any;
  savingSession = false;
  mode = 'hosted';
  exportAnalytics = false;
  isActor = false;
  isLoading = true;
  notFound = false;
  unavailable = false;
  unavailableError: any;
  hashParts: any;
  canPlay = false;
  accessDenied:any = null;

  constructor(
    // private sw: UpdateService,
    private router: Router,
    private route: ActivatedRoute,
    private scenarioService: ScenarioService,
    private playerSessionService: PlayerSessionService,
    private meta: Meta,
    private titleService: Title,
    private userService: UserService,
    private libraryService: LibraryService,
  ) {
    // check the service worker for updates
    // this.sw.checkForUpdates();
  }
  ngOnInit() {
    this.isLoading = true;
    // if it's local or scorm we'll have the meta data so get that
    // get the stuff..
    this.route.params.subscribe((params: any) => {
      let hash = params['hash'];
      if (hash) {
        let hashParts = hash.split('-');
        this.hashParts = hashParts;
        if (!hashParts[0] || !hashParts[1] || !hashParts[2]) {
          // console.log('Not found');
        } else {
          // load it
          this.scenarioId = hashParts[1];
          this.publishedHash = hashParts[2];
          // can they access this?
          this.libraryService.fetchAll().subscribe((responseData) => {
            let libraryItems = responseData;
            libraryItems.forEach((libraryItem: any) => {
              if (libraryItem.published_hash == this.publishedHash) {
                this.canPlay = true;
              }
            });
            if(!this.canPlay){
              this.accessDenied = true;
            }
            this.isLoading = false;
          });

          this.scenarioService
            .loadScenario(hashParts[0] + '/' + hashParts[2] + '.json')
            .subscribe((responseData) => {
              this.initScenario(responseData, hashParts);
              this.isLoading = false;
            });

          // check access

          // assign user data to user data?

          /*this.scenarioService.checkScenario(this.scenarioId).subscribe(
            (response) => {},
            (error) => {
              // an error so we're not allowed...
              this.unavailable = true;
              this.unavailableError = error.error;
            },

          );*/
        }
      }
    });

    // restart a session?
    this.playerSessionService.beforeRestartSession.subscribe(
      (beforeRestart) => {
        this.saveSessionData();
      },
    );
  }

  initScenario(scenario: any, hashParts: any) {
    this.scenario = scenario;

    // set the title
    this.titleService.setTitle(scenario.title);

    // max attempts?
    if (this.scenario.settings?.maxAttempts) {
      let attempts = localStorage.getItem(
        'ys-' + '-' + hashParts[0] + '-' + hashParts[2] + '-attemps',
      );
      let numAttempts = 0;
      if (!attempts) {
        attempts = '0';
      } else {
        numAttempts = +attempts;
      }
      // add this attempts
      numAttempts++;
      if (numAttempts > +this.scenario.settings?.maxAttempts) {
        // max reached..
        Swal.fire({
          icon: 'error',
          title: 'Maximum attempts reached',
          text: 'You have reached the maximum number of attempts allowed at this scenario.',
          showConfirmButton: false,
        });
      } else {
        localStorage.setItem(
          'ys-' + '-' + hashParts[1] + '-' + hashParts[2] + '-attemps',
          '' + numAttempts,
        );
      }
    }

    if (this.startStepId) {
      this.startStep = this.scenarioService.getStep(
        this.startStepId,
        this.scenario,
      );
    } else {
      this.startStep = this.scenarioService.getStartStep(this.scenario);
    }
    // init stuff
    this.scenarioService.loadFonts(this.scenario);
    // start the save session interval
    this.saveSessionInterval = setInterval(() => {
      this.saveSessionData();
    }, 10000);

    // get the session
    this.playerSessionService.sessionInitialised.subscribe((responseData) => {
      // set the user data?
      this.userService.userData.subscribe((userData: any) => {
        if (userData) {
          this.playerSessionService.setUserData({
            name: userData.first_name + userData.last_name,
          });
        }
      });
    });

    this.playerSessionService.sessionLogUpdated.subscribe((responseData) => {
      if (
        responseData == true &&
        !this.sessionCreated &&
        !this.savingSession &&
        (this.mode == 'hosted' || this.exportAnalytics)
      ) {
        this.savingSession = true;
        this.playerSessionService
          .create(
            this.scenarioId,
            this.playerSessionService.sessionData.id,
            this.publishedHash,
            JSON.stringify(this.playerSessionService.sessionData.user),
            JSON.stringify(this.playerSessionService.sessionData),
            JSON.stringify(this.playerSessionService.sessionLog),
            this.playerSessionService.sessionData.score,
            JSON.stringify(this.playerSessionService.sessionData.vars),
            JSON.stringify(this.playerSessionService.sessionData.route),
            this.playerSessionService.sessionData.duration,
            this.playerSessionService.sessionData.route.slice(-1).pop(),
            dayjs(this.playerSessionService.sessionData.lastActive).format(
              'YYYY-MM-DD HH:mm:ss',
            ),
          )
          .subscribe((sessionResponseData) => {
            this.sessionCreated = true;
            this.activeSessionId =
              sessionResponseData.body?.scenario_session_id;
            this.savingSession = false;
          });
        //this.playerSessionService.sessionLogUpdated.unsubscribe();
      }
    });
  }

  saveSessionData() {
    if (
      this.activeSessionId &&
      (this.mode == 'hosted' || this.exportAnalytics)
    ) {
      this.playerSessionService
        .update(
          this.activeSessionId,
          this.scenarioId,
          this.playerSessionService.sessionData.id,
          this.publishedHash,
          JSON.stringify(this.playerSessionService.sessionData.user),
          JSON.stringify(this.playerSessionService.sessionData),
          JSON.stringify(this.playerSessionService.sessionLog),
          this.playerSessionService.sessionData.score,
          JSON.stringify(this.playerSessionService.sessionData.vars),
          JSON.stringify(this.playerSessionService.sessionData.route),
          this.playerSessionService.sessionData.duration,
          this.playerSessionService.sessionData.route[
            this.playerSessionService.sessionData.route.length - 1
          ],
          dayjs(this.playerSessionService.sessionData.lastActive).format(
            'YYYY-MM-DD HH:mm:ss',
          ),
        )
        .subscribe((sessionResponseData) => {
          //  console.log('session saved');
        });
    }
  }

  ngOnDestroy() {
    clearInterval(this.saveSessionInterval);
  }

  @HostListener('window:unload', ['$event'])
  beforeUnloadHander(event: any) {
    this.saveSessionData();
  }
}
